import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth.js'
import Order from './modules/order.js'
import Forecast from './modules/forecast.js'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		loading: false,
		jobName: null,
		message: {},
		productCategories: {
			1: 'First Fix',
			2: 'Wire',
			3: 'Reticulation',
			4: 'Reticulation General',
			5: 'Final Fix',
			6: 'Final Fix General',
			7: 'Tools and Consumables',
			8: 'Common',
			9: 'Special Area',
			10: 'Carports'
		},
		productCategoriesKey: {
			'first_fix': 'First Fix',
			'wire': 'Wire',
			'reticulation': 'Reticulation',
			'reticulation_general': 'Reticulation General',
			'final_fix': 'Final Fix',
			'final_fix_general': 'Final Fix General',
			'tools': 'Tools and Consumables',
			'common': 'Common',
			'special_area': 'Special Area',
			'carports' : 'Carports'
		},
		productCategoriesIndex: {
			1: 'first_fix',
			2: 'wire',
			3: 'reticulation',
			4: 'reticulation_general',
			5: 'final_fix',
			6: 'final_fix_general',
			7: 'tools',
			8: 'common',
			9: 'special_area',
			10: 'carports'
		},
	},
	mutations: {
		setJobName (state, name) {
			state.jobName = name
		},
		setLoading (state, loading) {
			state.loading = loading
		},
		clearStatus (state) {
			state.message = {}
		},
		setStatus (state, message) {
			state.message = message
		},
	},
	getters: {
		jobName: state => state.jobName,
		flashStatus: state => state.message,
		isLoading: state => state.loading,
		getProductCategoryNameById: (state) => (id) => {
			return state.productCategories[id]
		},
		getProductCategoryNameByKey: (state) => (key) => {
			return state.productCategoriesKey[key]
		},
		getProductCategoryKeyByIndex: (state) => (index) => {
			return state.productCategoriesIndex[index]
		},
	},
	modules: {
		auth: Auth,
		order: Order,
		forecast: Forecast,
	}
})

export default store
